import React from 'react'
import PropTypes from 'prop-types'
import { constants } from 'common/helpers'

import messages from './messages'

import SubscriptionUndeliverableModal from 'components/modals/SubscriptionUndeliverableModal/SubscriptionUndeliverableModal'


const NeedUpdateAddressModal = ({ name, title }) => (
  <SubscriptionUndeliverableModal
    name={name}
    title={title}
    text={messages.text}
    isLimitedEditionMode
  />
)

NeedUpdateAddressModal.propTypes = {
  name: PropTypes.string,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
}

NeedUpdateAddressModal.defaultProps = {
  name: constants.modals.limitedEditionProducts.NeedUpdateAddress,
  title: messages.title,
}


export default NeedUpdateAddressModal
